package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Norfolk Island Flag (16x12dp)
 *
 * - ISO Alpha-2: NF
 * - ISO Alpha-3: NFK
 * - ISO Numeric: 574
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.NorfolkIsland: ImageVector by lazy {
    ImageVector.Builder(
        name = "Norfolk Island:NF:NFK:574:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF409100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11f, 0f)
                horizontalLineTo(16f)
                verticalLineTo(12f)
                horizontalLineTo(11f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF409100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(6f)
                verticalLineTo(12f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5f, 0f)
                horizontalLineTo(11f)
                verticalLineTo(12f)
                horizontalLineTo(5f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF409100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.348f, 9.385f)
                curveTo(5.57f, 9.512f, 5.325f, 9.132f, 5.325f, 9.132f)
                lineTo(5.423f, 9.052f)
                curveTo(5.488f, 8.998f, 5.71f, 9.016f, 5.925f, 9.034f)
                curveTo(6.03f, 9.043f, 6.134f, 9.052f, 6.217f, 9.052f)
                curveTo(6.339f, 9.052f, 6.478f, 9.033f, 6.624f, 9.014f)
                curveTo(6.782f, 8.994f, 6.947f, 8.972f, 7.103f, 8.972f)
                curveTo(7.403f, 8.972f, 6.217f, 8.58f, 5.964f, 8.82f)
                curveTo(5.711f, 9.061f, 5f, 8.709f, 5f, 8.509f)
                curveTo(5f, 8.372f, 5.262f, 8.422f, 5.5f, 8.467f)
                curveTo(5.611f, 8.488f, 5.717f, 8.509f, 5.79f, 8.509f)
                curveTo(6.018f, 8.509f, 5.562f, 8.064f, 5.325f, 8.064f)
                curveTo(5.087f, 8.064f, 5.562f, 7.961f, 5.79f, 7.961f)
                curveTo(5.92f, 7.961f, 6.04f, 7.994f, 6.144f, 8.023f)
                curveTo(6.223f, 8.045f, 6.292f, 8.064f, 6.348f, 8.064f)
                curveTo(6.478f, 8.064f, 5.693f, 7.727f, 5.562f, 7.727f)
                horizontalLineTo(6.217f)
                curveTo(6.442f, 7.727f, 6.497f, 7.758f, 6.549f, 7.788f)
                curveTo(6.595f, 7.815f, 6.64f, 7.841f, 6.804f, 7.841f)
                curveTo(7.151f, 7.841f, 6.961f, 7.652f, 6.961f, 7.652f)
                curveTo(6.961f, 7.652f, 5.79f, 7.53f, 5.562f, 7.362f)
                curveTo(5.408f, 7.249f, 5.821f, 7.289f, 6.212f, 7.326f)
                lineTo(6.212f, 7.326f)
                curveTo(6.399f, 7.344f, 6.582f, 7.362f, 6.693f, 7.362f)
                curveTo(7.039f, 7.362f, 5.964f, 7.115f, 5.79f, 7.115f)
                horizontalLineTo(6.582f)
                curveTo(6.756f, 7.115f, 6.946f, 7.171f, 7.146f, 7.23f)
                lineTo(7.146f, 7.23f)
                curveTo(7.366f, 7.294f, 7.598f, 7.362f, 7.832f, 7.362f)
                curveTo(8.077f, 7.362f, 7.597f, 7.215f, 7.07f, 7.054f)
                lineTo(7.07f, 7.054f)
                curveTo(6.644f, 6.924f, 6.187f, 6.785f, 6.057f, 6.705f)
                curveTo(5.923f, 6.623f, 6.025f, 6.655f, 6.211f, 6.713f)
                curveTo(6.428f, 6.78f, 6.757f, 6.883f, 6.961f, 6.883f)
                curveTo(7.339f, 6.883f, 6.457f, 6.511f, 6.217f, 6.511f)
                curveTo(5.978f, 6.511f, 5.748f, 6.404f, 5.964f, 6.304f)
                curveTo(6.097f, 6.242f, 6.442f, 6.335f, 6.743f, 6.415f)
                curveTo(6.932f, 6.466f, 7.104f, 6.511f, 7.194f, 6.511f)
                curveTo(7.303f, 6.511f, 7.384f, 6.554f, 7.469f, 6.599f)
                curveTo(7.567f, 6.651f, 7.671f, 6.705f, 7.832f, 6.705f)
                curveTo(8.133f, 6.705f, 7.194f, 6.304f, 6.804f, 6.304f)
                curveTo(6.414f, 6.304f, 6.348f, 6.115f, 6.582f, 6.115f)
                curveTo(6.817f, 6.115f, 6.057f, 5.792f, 6.057f, 5.792f)
                curveTo(6.057f, 5.792f, 5.947f, 5.564f, 6.217f, 5.564f)
                horizontalLineTo(6.582f)
                curveTo(6.707f, 5.564f, 6.457f, 5.167f, 6.217f, 5.167f)
                curveTo(5.978f, 5.167f, 6.187f, 5.047f, 6.582f, 5.047f)
                curveTo(6.823f, 5.047f, 6.964f, 5.13f, 7.133f, 5.23f)
                curveTo(7.242f, 5.295f, 7.363f, 5.366f, 7.53f, 5.427f)
                curveTo(7.957f, 5.582f, 7.635f, 5.167f, 7.53f, 5.167f)
                curveTo(7.425f, 5.167f, 6.348f, 4.829f, 6.348f, 4.829f)
                curveTo(6.348f, 4.829f, 6.457f, 4.705f, 6.348f, 4.535f)
                curveTo(6.265f, 4.408f, 6.609f, 4.473f, 6.818f, 4.512f)
                curveTo(6.887f, 4.525f, 6.94f, 4.535f, 6.961f, 4.535f)
                curveTo(7.01f, 4.535f, 7.153f, 4.571f, 7.328f, 4.614f)
                lineTo(7.328f, 4.614f)
                curveTo(7.446f, 4.644f, 7.578f, 4.677f, 7.707f, 4.705f)
                curveTo(8.028f, 4.775f, 6.62f, 4.188f, 6.457f, 4.188f)
                curveTo(6.295f, 4.188f, 6.804f, 4.091f, 7.103f, 4.091f)
                curveTo(7.251f, 4.091f, 7.322f, 4.115f, 7.394f, 4.138f)
                curveTo(7.469f, 4.163f, 7.545f, 4.188f, 7.707f, 4.188f)
                curveTo(8.028f, 4.188f, 7.103f, 3.845f, 6.804f, 3.845f)
                curveTo(6.504f, 3.845f, 6.681f, 3.549f, 6.804f, 3.549f)
                curveTo(6.852f, 3.549f, 6.972f, 3.565f, 7.12f, 3.584f)
                lineTo(7.12f, 3.584f)
                lineTo(7.12f, 3.584f)
                horizontalLineTo(7.12f)
                lineTo(7.12f, 3.584f)
                lineTo(7.12f, 3.584f)
                lineTo(7.12f, 3.584f)
                curveTo(7.351f, 3.615f, 7.648f, 3.654f, 7.832f, 3.654f)
                curveTo(7.972f, 3.654f, 7.844f, 3.615f, 7.657f, 3.557f)
                lineTo(7.657f, 3.557f)
                lineTo(7.657f, 3.557f)
                curveTo(7.443f, 3.492f, 7.152f, 3.402f, 7.103f, 3.322f)
                curveTo(7.05f, 3.233f, 7.159f, 3.25f, 7.348f, 3.278f)
                lineTo(7.348f, 3.278f)
                curveTo(7.382f, 3.283f, 7.419f, 3.288f, 7.458f, 3.293f)
                curveTo(7.587f, 3.361f, 7.695f, 3.405f, 7.711f, 3.353f)
                curveTo(7.716f, 3.338f, 7.726f, 3.328f, 7.739f, 3.32f)
                curveTo(7.769f, 3.321f, 7.8f, 3.322f, 7.832f, 3.322f)
                curveTo(8.01f, 3.322f, 7.928f, 3.295f, 7.756f, 3.262f)
                lineTo(7.74f, 3.258f)
                curveTo(7.48f, 3.178f, 6.915f, 3.007f, 7.126f, 3.113f)
                curveTo(7.168f, 3.133f, 7.214f, 3.159f, 7.262f, 3.185f)
                curveTo(7.12f, 3.167f, 7.001f, 3.154f, 6.961f, 3.154f)
                curveTo(6.818f, 3.154f, 6.675f, 3.043f, 6.961f, 3.043f)
                horizontalLineTo(7.53f)
                curveTo(7.353f, 3.043f, 7.103f, 3.043f, 7.103f, 2.904f)
                curveTo(7.103f, 2.809f, 7.301f, 2.844f, 7.483f, 2.875f)
                curveTo(7.569f, 2.89f, 7.651f, 2.904f, 7.707f, 2.904f)
                curveTo(7.885f, 2.904f, 7.929f, 2.904f, 7.832f, 2.821f)
                curveTo(7.739f, 2.743f, 7.422f, 2.743f, 7.224f, 2.743f)
                lineTo(7.194f, 2.743f)
                curveTo(7.001f, 2.743f, 7.604f, 2.642f, 7.832f, 2.642f)
                curveTo(7.87f, 2.642f, 7.887f, 2.642f, 7.887f, 2.642f)
                curveTo(7.887f, 2.641f, 7.876f, 2.64f, 7.857f, 2.638f)
                curveTo(7.758f, 2.629f, 7.429f, 2.597f, 7.194f, 2.49f)
                curveTo(6.983f, 2.395f, 7.168f, 2.419f, 7.409f, 2.45f)
                curveTo(7.554f, 2.469f, 7.719f, 2.49f, 7.832f, 2.49f)
                curveTo(8.133f, 2.49f, 7.707f, 2.288f, 7.387f, 2.288f)
                curveTo(7.13f, 2.288f, 7.253f, 2.217f, 7.412f, 2.126f)
                lineTo(7.412f, 2.126f)
                curveTo(7.451f, 2.104f, 7.492f, 2.08f, 7.53f, 2.056f)
                curveTo(7.646f, 1.983f, 7.73f, 2.108f, 7.78f, 2.18f)
                curveTo(7.814f, 2.23f, 7.832f, 2.256f, 7.832f, 2.179f)
                curveTo(7.832f, 2.103f, 7.812f, 2.055f, 7.796f, 2.03f)
                curveTo(7.805f, 2.037f, 7.816f, 2.046f, 7.832f, 2.056f)
                curveTo(7.956f, 2.139f, 7.832f, 1.839f, 7.832f, 1.839f)
                curveTo(7.832f, 1.839f, 7.707f, 1.756f, 7.832f, 1.756f)
                curveTo(7.956f, 1.756f, 7.792f, 1.613f, 7.707f, 1.613f)
                curveTo(7.623f, 1.613f, 7.929f, 1.477f, 7.929f, 1.477f)
                lineTo(7.996f, 0.9f)
                curveTo(7.996f, 0.9f, 8.162f, 1.529f, 8.162f, 1.613f)
                verticalLineTo(2.056f)
                curveTo(8.162f, 2.161f, 8.088f, 2.235f, 8.038f, 2.284f)
                curveTo(7.975f, 2.346f, 7.952f, 2.369f, 8.162f, 2.369f)
                curveTo(8.541f, 2.369f, 8.525f, 2.49f, 8.294f, 2.49f)
                curveTo(8.064f, 2.49f, 8.36f, 2.642f, 8.774f, 2.642f)
                curveTo(9.188f, 2.642f, 8.427f, 2.821f, 8.162f, 2.821f)
                curveTo(7.897f, 2.821f, 8.427f, 2.904f, 8.774f, 2.904f)
                curveTo(9.008f, 2.904f, 8.768f, 2.985f, 8.546f, 3.06f)
                curveTo(8.44f, 3.096f, 8.337f, 3.13f, 8.294f, 3.154f)
                curveTo(8.226f, 3.191f, 8.395f, 3.189f, 8.575f, 3.18f)
                curveTo(8.48f, 3.207f, 8.387f, 3.236f, 8.315f, 3.258f)
                curveTo(8.229f, 3.284f, 8.2f, 3.293f, 8.201f, 3.297f)
                curveTo(8.201f, 3.298f, 8.209f, 3.299f, 8.221f, 3.299f)
                curveTo(8.257f, 3.301f, 8.33f, 3.305f, 8.345f, 3.353f)
                curveTo(8.366f, 3.424f, 8.564f, 3.314f, 8.75f, 3.21f)
                curveTo(8.78f, 3.193f, 8.81f, 3.176f, 8.838f, 3.161f)
                curveTo(8.887f, 3.157f, 8.919f, 3.154f, 8.919f, 3.154f)
                curveTo(8.919f, 3.154f, 9.09f, 3.351f, 9.09f, 3.472f)
                curveTo(9.09f, 3.543f, 8.865f, 3.563f, 8.624f, 3.586f)
                lineTo(8.6f, 3.588f)
                curveTo(8.612f, 3.572f, 8.561f, 3.58f, 8.486f, 3.599f)
                curveTo(8.361f, 3.612f, 8.243f, 3.628f, 8.162f, 3.654f)
                curveTo(8.085f, 3.679f, 8.098f, 3.689f, 8.161f, 3.692f)
                lineTo(8.144f, 3.697f)
                curveTo(8.085f, 3.715f, 8.064f, 3.721f, 8.065f, 3.725f)
                curveTo(8.065f, 3.726f, 8.071f, 3.728f, 8.08f, 3.729f)
                horizontalLineTo(8.08f)
                curveTo(8.106f, 3.734f, 8.158f, 3.744f, 8.173f, 3.792f)
                curveTo(8.195f, 3.863f, 8.327f, 3.773f, 8.451f, 3.688f)
                lineTo(8.463f, 3.68f)
                lineTo(8.581f, 3.672f)
                lineTo(8.581f, 3.672f)
                curveTo(8.717f, 3.663f, 8.847f, 3.654f, 8.919f, 3.654f)
                curveTo(9.142f, 3.654f, 8.695f, 3.761f, 8.525f, 3.761f)
                curveTo(8.452f, 3.761f, 8.544f, 3.778f, 8.683f, 3.803f)
                curveTo(8.872f, 3.837f, 9.148f, 3.886f, 9.226f, 3.933f)
                curveTo(9.319f, 3.988f, 9.045f, 3.967f, 8.802f, 3.949f)
                lineTo(8.802f, 3.949f)
                curveTo(8.69f, 3.941f, 8.586f, 3.933f, 8.525f, 3.933f)
                curveTo(8.33f, 3.933f, 8.294f, 4.091f, 8.427f, 4.091f)
                horizontalLineTo(8.919f)
                curveTo(9.105f, 4.091f, 9.298f, 4.376f, 9.226f, 4.376f)
                curveTo(9.204f, 4.376f, 9.157f, 4.39f, 9.092f, 4.411f)
                curveTo(8.942f, 4.458f, 8.694f, 4.535f, 8.427f, 4.535f)
                curveTo(8.045f, 4.535f, 8.919f, 4.536f, 9.09f, 4.535f)
                curveTo(9.262f, 4.535f, 9.751f, 4.536f, 9.751f, 4.705f)
                curveTo(9.751f, 4.81f, 9.658f, 4.833f, 9.537f, 4.863f)
                curveTo(9.463f, 4.882f, 9.379f, 4.903f, 9.298f, 4.947f)
                curveTo(9.085f, 5.062f, 9.936f, 5.167f, 9.936f, 5.167f)
                curveTo(9.936f, 5.167f, 9.599f, 5.272f, 9.435f, 5.272f)
                curveTo(9.271f, 5.272f, 9.511f, 5.427f, 9.936f, 5.427f)
                curveTo(10.264f, 5.427f, 10.168f, 5.605f, 10.107f, 5.717f)
                lineTo(10.107f, 5.717f)
                curveTo(10.09f, 5.75f, 10.075f, 5.777f, 10.075f, 5.792f)
                curveTo(10.075f, 5.822f, 10.013f, 5.847f, 9.923f, 5.884f)
                curveTo(9.807f, 5.931f, 9.646f, 5.997f, 9.511f, 6.115f)
                curveTo(9.357f, 6.25f, 9.545f, 6.21f, 9.757f, 6.165f)
                lineTo(9.757f, 6.165f)
                curveTo(9.873f, 6.141f, 9.996f, 6.115f, 10.075f, 6.115f)
                curveTo(10.298f, 6.115f, 10.393f, 6.124f, 10.321f, 6.232f)
                curveTo(10.248f, 6.34f, 9.599f, 6.511f, 9.435f, 6.511f)
                horizontalLineTo(10.321f)
                curveTo(10.566f, 6.511f, 10.252f, 6.705f, 9.936f, 6.705f)
                curveTo(9.724f, 6.705f, 9.605f, 6.785f, 9.527f, 6.838f)
                curveTo(9.489f, 6.864f, 9.46f, 6.883f, 9.435f, 6.883f)
                horizontalLineTo(10.075f)
                curveTo(10.108f, 6.883f, 10.144f, 6.831f, 10.176f, 6.783f)
                curveTo(10.205f, 6.741f, 10.232f, 6.702f, 10.252f, 6.705f)
                curveTo(10.541f, 6.751f, 10.411f, 7.115f, 10.252f, 7.115f)
                curveTo(10.069f, 7.115f, 9.511f, 7.238f, 9.599f, 7.362f)
                curveTo(9.642f, 7.422f, 9.708f, 7.395f, 9.815f, 7.351f)
                curveTo(9.93f, 7.304f, 10.091f, 7.238f, 10.321f, 7.238f)
                curveTo(10.765f, 7.238f, 10.363f, 7.362f, 10.252f, 7.362f)
                curveTo(10.14f, 7.362f, 9.669f, 7.452f, 9.511f, 7.53f)
                curveTo(9.406f, 7.582f, 9.772f, 7.564f, 10.135f, 7.547f)
                curveTo(10.316f, 7.539f, 10.496f, 7.53f, 10.618f, 7.53f)
                curveTo(10.983f, 7.53f, 9.751f, 7.841f, 9.298f, 7.841f)
                curveTo(8.846f, 7.841f, 9.599f, 7.961f, 9.751f, 7.961f)
                curveTo(9.809f, 7.961f, 9.922f, 7.976f, 10.061f, 7.995f)
                lineTo(10.061f, 7.995f)
                horizontalLineTo(10.061f)
                curveTo(10.284f, 8.025f, 10.576f, 8.064f, 10.817f, 8.064f)
                curveTo(11.208f, 8.064f, 10.425f, 8.322f, 10.075f, 8.322f)
                lineTo(9.995f, 8.322f)
                curveTo(9.683f, 8.32f, 9.448f, 8.319f, 9.599f, 8.509f)
                curveTo(9.683f, 8.614f, 9.963f, 8.585f, 10.255f, 8.555f)
                curveTo(10.532f, 8.527f, 10.821f, 8.497f, 10.963f, 8.58f)
                curveTo(11.219f, 8.729f, 10.087f, 8.716f, 9.599f, 8.711f)
                horizontalLineTo(9.599f)
                horizontalLineTo(9.599f)
                curveTo(9.529f, 8.71f, 9.473f, 8.709f, 9.435f, 8.709f)
                curveTo(9.135f, 8.709f, 9.735f, 8.82f, 10.252f, 8.82f)
                lineTo(10.317f, 8.82f)
                curveTo(10.779f, 8.82f, 10.888f, 8.82f, 10.888f, 8.972f)
                curveTo(10.888f, 9.105f, 9.883f, 9.071f, 9.463f, 9.056f)
                curveTo(9.383f, 9.054f, 9.325f, 9.052f, 9.298f, 9.052f)
                curveTo(9.218f, 9.052f, 9.171f, 9.1f, 9.123f, 9.151f)
                curveTo(9.071f, 9.204f, 9.018f, 9.26f, 8.919f, 9.26f)
                curveTo(8.837f, 9.26f, 8.799f, 9.208f, 8.764f, 9.16f)
                curveTo(8.717f, 9.096f, 8.676f, 9.041f, 8.544f, 9.132f)
                curveTo(8.313f, 9.292f, 8.774f, 10.9f, 8.774f, 10.9f)
                horizontalLineTo(7.53f)
                verticalLineTo(9.385f)
                curveTo(7.53f, 9.385f, 7.126f, 9.259f, 6.348f, 9.385f)
                close()
                moveTo(7.777f, 2.008f)
                curveTo(7.775f, 2.009f, 7.78f, 2.016f, 7.796f, 2.03f)
                curveTo(7.787f, 2.015f, 7.778f, 2.008f, 7.777f, 2.008f)
                close()
                moveTo(7.344f, 8.012f)
                curveTo(7.147f, 7.938f, 7.645f, 7.934f, 7.876f, 7.934f)
                curveTo(7.95f, 7.934f, 7.976f, 7.934f, 7.978f, 7.94f)
                curveTo(7.979f, 7.944f, 7.972f, 7.949f, 7.962f, 7.958f)
                curveTo(7.933f, 7.982f, 7.876f, 8.029f, 7.876f, 8.124f)
                curveTo(7.876f, 8.266f, 7.689f, 8.175f, 7.513f, 8.089f)
                lineTo(7.513f, 8.089f)
                lineTo(7.513f, 8.089f)
                lineTo(7.513f, 8.089f)
                curveTo(7.453f, 8.059f, 7.394f, 8.031f, 7.344f, 8.012f)
                close()
                moveTo(7.751f, 7.433f)
                curveTo(7.521f, 7.433f, 7.023f, 7.437f, 7.219f, 7.511f)
                curveTo(7.269f, 7.529f, 7.328f, 7.558f, 7.388f, 7.587f)
                lineTo(7.388f, 7.587f)
                lineTo(7.388f, 7.587f)
                lineTo(7.388f, 7.587f)
                curveTo(7.564f, 7.674f, 7.751f, 7.765f, 7.751f, 7.623f)
                curveTo(7.751f, 7.528f, 7.809f, 7.48f, 7.838f, 7.457f)
                curveTo(7.848f, 7.448f, 7.854f, 7.443f, 7.853f, 7.439f)
                curveTo(7.852f, 7.433f, 7.825f, 7.433f, 7.751f, 7.433f)
                close()
                moveTo(7.336f, 7.098f)
                curveTo(7.175f, 7.059f, 7.582f, 7.057f, 7.77f, 7.057f)
                curveTo(7.832f, 7.057f, 7.853f, 7.057f, 7.853f, 7.06f)
                curveTo(7.854f, 7.062f, 7.849f, 7.065f, 7.84f, 7.069f)
                curveTo(7.817f, 7.082f, 7.77f, 7.107f, 7.77f, 7.157f)
                curveTo(7.77f, 7.231f, 7.617f, 7.183f, 7.473f, 7.138f)
                curveTo(7.424f, 7.123f, 7.376f, 7.108f, 7.336f, 7.098f)
                close()
                moveTo(7.74f, 5.513f)
                curveTo(7.48f, 5.433f, 6.915f, 5.263f, 7.126f, 5.368f)
                curveTo(7.18f, 5.395f, 7.242f, 5.43f, 7.306f, 5.465f)
                curveTo(7.492f, 5.569f, 7.689f, 5.68f, 7.711f, 5.609f)
                curveTo(7.726f, 5.561f, 7.798f, 5.557f, 7.834f, 5.555f)
                curveTo(7.847f, 5.554f, 7.855f, 5.554f, 7.855f, 5.552f)
                curveTo(7.856f, 5.548f, 7.827f, 5.539f, 7.74f, 5.513f)
                close()
                moveTo(7.126f, 4.867f)
                curveTo(6.915f, 4.762f, 7.48f, 4.932f, 7.74f, 5.012f)
                curveTo(7.827f, 5.038f, 7.856f, 5.047f, 7.855f, 5.051f)
                curveTo(7.855f, 5.053f, 7.847f, 5.053f, 7.834f, 5.054f)
                curveTo(7.798f, 5.056f, 7.726f, 5.06f, 7.711f, 5.107f)
                curveTo(7.689f, 5.179f, 7.492f, 5.068f, 7.306f, 4.964f)
                lineTo(7.306f, 4.964f)
                curveTo(7.242f, 4.928f, 7.18f, 4.894f, 7.126f, 4.867f)
                close()
                moveTo(7.74f, 4.385f)
                curveTo(7.48f, 4.306f, 6.915f, 4.135f, 7.126f, 4.24f)
                curveTo(7.18f, 4.267f, 7.242f, 4.302f, 7.306f, 4.337f)
                curveTo(7.492f, 4.442f, 7.689f, 4.552f, 7.711f, 4.481f)
                curveTo(7.726f, 4.433f, 7.798f, 4.429f, 7.834f, 4.427f)
                curveTo(7.847f, 4.427f, 7.855f, 4.426f, 7.855f, 4.424f)
                curveTo(7.856f, 4.421f, 7.827f, 4.412f, 7.74f, 4.385f)
                close()
                moveTo(8.305f, 7.809f)
                curveTo(8.535f, 7.809f, 9.033f, 7.813f, 8.836f, 7.887f)
                curveTo(8.787f, 7.905f, 8.728f, 7.934f, 8.668f, 7.963f)
                lineTo(8.668f, 7.963f)
                lineTo(8.668f, 7.963f)
                curveTo(8.491f, 8.05f, 8.305f, 8.141f, 8.305f, 7.999f)
                curveTo(8.305f, 7.904f, 8.247f, 7.856f, 8.218f, 7.832f)
                curveTo(8.208f, 7.824f, 8.201f, 7.819f, 8.202f, 7.815f)
                curveTo(8.204f, 7.809f, 8.23f, 7.809f, 8.305f, 7.809f)
                close()
                moveTo(8.836f, 7.511f)
                curveTo(9.033f, 7.437f, 8.535f, 7.433f, 8.305f, 7.433f)
                curveTo(8.23f, 7.433f, 8.204f, 7.433f, 8.202f, 7.439f)
                curveTo(8.201f, 7.443f, 8.208f, 7.448f, 8.218f, 7.457f)
                curveTo(8.247f, 7.48f, 8.305f, 7.528f, 8.305f, 7.623f)
                curveTo(8.305f, 7.765f, 8.491f, 7.674f, 8.668f, 7.587f)
                lineTo(8.668f, 7.587f)
                lineTo(8.668f, 7.587f)
                lineTo(8.668f, 7.587f)
                curveTo(8.728f, 7.558f, 8.787f, 7.529f, 8.836f, 7.511f)
                close()
                moveTo(9.145f, 6.644f)
                lineTo(9.145f, 6.644f)
                curveTo(9.165f, 6.639f, 9.166f, 6.639f, 9.139f, 6.645f)
                curveTo(9.086f, 6.658f, 8.975f, 6.702f, 8.85f, 6.751f)
                lineTo(8.85f, 6.751f)
                lineTo(8.85f, 6.751f)
                curveTo(8.597f, 6.851f, 8.286f, 6.973f, 8.286f, 6.906f)
                curveTo(8.286f, 6.856f, 8.239f, 6.831f, 8.215f, 6.819f)
                curveTo(8.207f, 6.814f, 8.202f, 6.812f, 8.202f, 6.81f)
                curveTo(8.203f, 6.806f, 8.224f, 6.806f, 8.286f, 6.806f)
                curveTo(8.443f, 6.806f, 9.042f, 6.668f, 9.145f, 6.644f)
                close()
                moveTo(8.929f, 5.117f)
                curveTo(9.14f, 5.012f, 8.576f, 5.183f, 8.315f, 5.262f)
                curveTo(8.229f, 5.289f, 8.2f, 5.298f, 8.201f, 5.301f)
                curveTo(8.201f, 5.303f, 8.209f, 5.304f, 8.221f, 5.304f)
                curveTo(8.257f, 5.306f, 8.33f, 5.31f, 8.345f, 5.358f)
                curveTo(8.366f, 5.429f, 8.564f, 5.319f, 8.75f, 5.214f)
                curveTo(8.814f, 5.179f, 8.876f, 5.144f, 8.929f, 5.117f)
                close()
                moveTo(8.315f, 5.764f)
                curveTo(8.576f, 5.684f, 9.14f, 5.514f, 8.929f, 5.619f)
                curveTo(8.876f, 5.645f, 8.814f, 5.68f, 8.75f, 5.716f)
                curveTo(8.564f, 5.82f, 8.366f, 5.93f, 8.345f, 5.859f)
                curveTo(8.33f, 5.811f, 8.257f, 5.807f, 8.221f, 5.806f)
                curveTo(8.209f, 5.805f, 8.201f, 5.804f, 8.201f, 5.803f)
                curveTo(8.2f, 5.799f, 8.229f, 5.79f, 8.315f, 5.764f)
                close()
                moveTo(8.929f, 4.616f)
                curveTo(9.14f, 4.511f, 8.576f, 4.682f, 8.315f, 4.761f)
                curveTo(8.229f, 4.788f, 8.2f, 4.797f, 8.201f, 4.8f)
                curveTo(8.201f, 4.802f, 8.209f, 4.802f, 8.221f, 4.803f)
                curveTo(8.257f, 4.805f, 8.33f, 4.809f, 8.345f, 4.857f)
                curveTo(8.366f, 4.928f, 8.564f, 4.818f, 8.75f, 4.713f)
                curveTo(8.814f, 4.678f, 8.876f, 4.643f, 8.929f, 4.616f)
                close()
                moveTo(8.144f, 4.323f)
                curveTo(8.324f, 4.268f, 8.713f, 4.151f, 8.571f, 4.235f)
                curveTo(8.535f, 4.257f, 8.493f, 4.285f, 8.451f, 4.314f)
                curveTo(8.327f, 4.4f, 8.195f, 4.49f, 8.173f, 4.419f)
                curveTo(8.158f, 4.371f, 8.106f, 4.361f, 8.08f, 4.356f)
                horizontalLineTo(8.08f)
                curveTo(8.071f, 4.354f, 8.065f, 4.353f, 8.065f, 4.351f)
                curveTo(8.064f, 4.348f, 8.085f, 4.341f, 8.144f, 4.323f)
                close()
                moveTo(8.259f, 6.23f)
                curveTo(8.052f, 6.23f, 8.259f, 6.067f, 8.259f, 6.067f)
                horizontalLineTo(8.365f)
                curveTo(8.401f, 6.067f, 8.434f, 6.052f, 8.477f, 6.032f)
                curveTo(8.559f, 5.994f, 8.678f, 5.939f, 8.934f, 5.939f)
                curveTo(9.323f, 5.939f, 8.465f, 6.23f, 8.259f, 6.23f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun NorfolkIslandPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.NorfolkIsland,
            contentDescription = "Norfolk Island Flag"
        )
    }
}
